/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/orgSelection/OrgPicker.Props" />
import { GitHubOrgOrUser } from "Wit/Clients/Internal/Contracts/WorkItemTracking";

export interface IOrgPickerProps {
    onSelectedOrgChanged: (gitHubOrgOrUser: GitHubOrgOrUser) => void;
    orgList: GitHubOrgOrUser[];
}
